module.exports = __webpack_public_path__ + "img/crear_active.aeebc89c.svg";